/* eslint @typescript-eslint/explicit-function-return-type: off */

export const addYears = (date, years) => {
  const ret = new Date(date.valueOf());
  ret.setFullYear(date.getFullYear() + years);
  return ret;
};

export const addMonths = (date, months) => {
  const ret = new Date(date.valueOf());
  ret.setMonth(date.getMonth() + months);
  return ret;
};

export const addDays = (date, days) => {
  const ret = new Date(date.valueOf());
  ret.setDate(date.getDate() + days);
  return ret;
};

export const today = () => new Date();
export const yesterday = () => addDays(new Date(), -1);

export const beginningOfYear = (date) => {
  const ret = new Date(date.valueOf());
  ret.setMonth(0);
  ret.setDate(1);
  return ret;
};

export const endOfYear = (date) => {
  const ret = new Date(date.valueOf());
  ret.setMonth(11);
  ret.setDate(31);
  return ret;
};

export const beginningOfMonth = (date) => {
  const ret = new Date(date.valueOf());
  ret.setDate(1);
  return ret;
};

export const endOfMonth = (date) => {
  return addDays(beginningOfMonth(addMonths(date, 1)), -1);
};

export const formatDate = (dateString) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(Date.parse(dateString));
  return date.toLocaleDateString();
};

export const formatDateTime = (dateString) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(Date.parse(dateString));
  return date.toLocaleString();
};

export const dateToString = (date) => {
  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const stringToDate = (dateString) => {
  if (!dateString) return null;

  const parts = dateString.split('-');
  if (parts.length !== 3) return null;

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;

  const date = new Date(year, month, day);

  if (
    date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day
  ) {
    return date;
  }

  return null;
};

export const getDaysBetweenDates = (startedOn, endedOn) => {
  const startedOnDate = stringToDate(startedOn);
  const endedOnDate = stringToDate(endedOn);

  if (!startedOnDate || !endedOnDate) return null;

  const timeDiff = Math.abs(endedOnDate.getTime() - startedOnDate.getTime());
  const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

  return dayDiff;
};

export const isValidDateString = (dateString) => {
  if (!dateString) return false;

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(dateString)) return false;

  return stringToDate(dateString) !== null;
};
